const styles = {
    background : {
        backgroundImage: `url(${require('../../images/about2.png')})`, // Import the image
        backgroundSize: 'cover', // Adjust background size as needed
        height: '70vh',
        position:'relative',
        backgroundColor:'white',
        backgroundRepeat:'no-repeat'
    },
    text : {
        position:'absolute',
        color:'#171520',
        right:'0',
        top:'35vh'
    }
};
export default styles;